<template>
	<CreationWizardStepWrapper>
		<template #header>
			<ChooseAppForAddOnFeatureHeader v-bind="$props" v-on="$listeners" />
		</template>
		<ChooseApp
			class="height-100"
			:selectedAppId="selectedAppId"
			@selectApp="selectApp"
			itemName="add-on"
			availableItems="triggers and contexts"
		/>
	</CreationWizardStepWrapper>
</template>

<script>
import WizardStepMixin from '../WizardStepMixin';

import props from './ChooseAppForAddOnFeature.props';
import ChooseAppForAddOnFeatureHeader from './ChooseAppForAddOnFeatureHeader.vue';
import ChooseApp from '../common/ChooseApp.vue';

export default {
	name: 'ChooseAppForAddOnFeature',
	mixins: [WizardStepMixin],
	props,
	components: { ChooseApp, ChooseAppForAddOnFeatureHeader },
	methods: {
		selectApp(value) {
			this.updateState({ key: 'selectedAppId', value });
			this.nextStep();
		},
	},
};
</script>

<style lang="scss" scoped></style>
